import { render, staticRenderFns } from "./MyTipsterTips.vue?vue&type=template&id=075e2138&"
import script from "./MyTipsterTips.vue?vue&type=script&lang=js&"
export * from "./MyTipsterTips.vue?vue&type=script&lang=js&"
import style0 from "./MyTipsterTips.vue?vue&type=style&index=0&id=075e2138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports